import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { BrewSensoryFormsSection } from "./brew-sensory-questions-section";
import { BrewSensoryTemplatesSection } from "./brew-sensory-templates-section";

export function BrewSensoryConfigSection() {
  const [tab, setTab] = useState("forms");

  return (
    <div className="space-y-4">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="forms">Forms</TabsTrigger>
          <TabsTrigger value="templates">Templates</TabsTrigger>
        </TabsList>

        <TabsContent value="forms" className="mt-4">
          <BrewSensoryFormsSection />
        </TabsContent>
        <TabsContent value="templates" className="mt-4">
          <BrewSensoryTemplatesSection />
        </TabsContent>
      </Tabs>
    </div>
  );
}
